export default "__VITE_ASSET__at38tscm__"